/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Integration_Off_HintInputs */

const vi_grower_area_camera_integration_off_hint = /** @type {(inputs: Grower_Area_Camera_Integration_Off_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật lại ở màn Cấu hình SmartLab để xem camera vùng trồng.`)
};

/**

* @param {Grower_Area_Camera_Integration_Off_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_integration_off_hint = /** @type {((inputs?: Grower_Area_Camera_Integration_Off_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Integration_Off_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_integration_off_hint(inputs)
});